import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { createFilterOptions } from '@mui/material/Autocomplete';
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from '@mui/icons-material/Help';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Primarytheme from './theme';
import { useReducer, useEffect } from "react"


export default function AutocompleteMultival({ opt, id, conf, updateConf, setConf }) {

    const initialVal = conf.selectedPaginationOptions[id].list;

    //Hook useReducer per il pattern State Reducer : https://react.dev/learn/extracting-state-logic-into-a-reducer
    const [options, dispatch] = useReducer(AutocompleteMultivalReducer, { list: initialVal, conf: conf });

    useEffect(() => {
        setConf(options.conf);
    }, [options.conf]);

    const handleOptionsChange = async (selectedOptions) => {
        dispatch({
            type: "change",
            payload: {
                selectedOptions: selectedOptions,
                optId: id,
                conf: conf,
            }
        })
    }

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.name,
    });

    return (
        <Autocomplete
            size='small'
            multiple
            id={id.toString()}
            options={options.list}
            defaultValue={undefined}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={opt.nome}
                />
            )}
            renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                    <li key={key} {...optionProps}>
                        <Stack direction='row' alignItems='center' key={opt.nome + 'stack'} justifyContent="space-between" width="100%">
                            {option.name}
                            <Tooltip title={
                                <Typography variant='caption' >
                                    {option.desc}
                                </Typography>}>
                                <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                            </Tooltip>
                        </Stack>
                    </li>
                );
            }}
            getOptionLabel={(option) => option.name}
            filterSelectedOptions
            disableCloseOnSelect
            filterOptions={filterOptions}
            sx={{ mt: 0, width: opt.width }}
            onChange={async (event, selectedOptions) => await handleOptionsChange(selectedOptions)}
        />
    )
}

function AutocompleteMultivalReducer(options, action) {

    const handleChange = () => {
        const newConf = { ...action.payload.conf };
        newConf.selectedPaginationOptions[action.payload.optId].value = action.payload.selectedOptions;
        return newConf
    }

    switch (action.type) {
        case 'change': {
            const newConf = handleChange()
            return { list: options.list, conf: newConf };
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }

    }
}